import axios from "axios";
import toQueryString from "../common/utils/to-query-string";

const getRules = (query) => axios.get(toQueryString("api/v1/rule-managements?", query));

const createRule = (rule) => axios.post("api/v1/rule-managements", rule);

const updateRule = (id, rule) =>
  axios.put(`api/v1/rule-managements/${id}`, rule);

const deleteRule = (id) => axios.delete(`api/v1/rule-managements/${id}`);

const removeBulk = (ids) =>
  axios.delete("api/v1/rule-managements/bulk", { data: { ids } });

const ApiRuleManagement = {
  getRules,
  createRule,
  updateRule,
  deleteRule,
  removeBulk
};

export default ApiRuleManagement;
